module.exports = __webpack_public_path__ + "static/media/js.45664c20.jpg";